import { IMenuAccordionProps } from '@/interfaces/menu';
import { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import UseTraceItemShipping from '../../../hooks/UseTraceItemShipping';
import { normalizeWords } from '../../../utils/normalizeWords';
import SubmenuElement from '../submenuElement/submenuElement';
import { getLocationRef } from '@/utils/location';
import dynamicClass from 'clsx';
import { Link } from 'gatsby';

import './menuAccordion.scss';

const MenuAccordion = (props: IMenuAccordionProps) => {
    const { category, index, setActiveItem, activeItem, children } = props;

    const [isActive, toggleActive] = useState(false);
    const { gigyaContext, userInfoContext } = useContext(GlobalContext);
    const [thirdFileMenu, setThirdFileMenu] = useState<any>([]);
    const [selectedSubMenuIndex, setSelectedSubMenuIndex] =
        useState<number>(-1);

    const onItemTraceShiping = () => {
        if (!gigyaContext?.gigyaAccount) return;
        return UseTraceItemShipping(
            gigyaContext?.gigyaAccount?.profile.firstName +
                ' ' +
                (gigyaContext.gigyaAccount.data.secondName
                    ? gigyaContext.gigyaAccount.data.secondName + ' '
                    : '') +
                gigyaContext.gigyaAccount.profile.lastName +
                (gigyaContext.gigyaAccount.data.secondLastName
                    ? ' ' + gigyaContext.gigyaAccount.data.secondLastName
                    : ''),
            gigyaContext?.gigyaAccount?.data.docNumber,
            gigyaContext?.gigyaAccount?.data.docType,
            gigyaContext?.gigyaAccount?.profile.email,
            'redirection',
            `${validateTitle(category.titulo)} ${normalizeWords(
                category.nombre
            )}`,
            userInfoContext.data?.userJwt
        );
    };

    const validateTitle = (title: string) => {
        if (!title) return '';
        return title.includes('Conoce comfama')
            ? normalizeWords('Conoce Comfama')
            : 'ServiciosYTramites' + ' :: ';
    };

    useEffect(() => {
        index !== activeItem && toggleActive(false);
    }, [activeItem]);

    const menuList = (
        subcat: any,
        k: number,
        slug: string,
        bold: boolean,
        traceLabel?: string,
        isTitle?: boolean,
        onlyRedirection?: boolean
    ) => (
        <li key={`cat${k}`}>
            <SubmenuElement
                item={subcat}
                index={k}
                subOption={false}
                // bold={boldSub}
                isTitle={isTitle}
                tooltipLeft={false}
                traceLabel={traceLabel}
                isIcon={props.isIcon}
                onlyRedirection={onlyRedirection}
            />
        </li>
    );

    const existCategory =
        category.referencias && category.referencias.length > 0;

    const classMenuAccordionBtnIcon = dynamicClass('a-menu-accord__btn-icon', {
        'a-menu-accord__btn-icon--active': isActive,
    });

    const classMenuAccordionBtn = dynamicClass('a-menu-accord__btn', {
        'a-menu-accord__btn--active': isActive,
    });

    const classMenuAccordionSub = dynamicClass('a-menu-accord__sub', {
        'a-menu-accord__sub--active': isActive && index === activeItem,
    });

    const selectThirdFileMenu = (index) => {
        if (thirdFileMenu.length > 0) {
            setThirdFileMenu([]);
        } else {
            const thirdContent = category.referencias[index].referencias;
            return setThirdFileMenu(thirdContent);
        }
    };

    const handleFileMenuChange = (index) => {
        if (selectedSubMenuIndex !== -1) {
            setSelectedSubMenuIndex(-1);
        } else {
            setSelectedSubMenuIndex(index);
        }
    };

    return (
        <div className="a-menu-accord">
            {category.referencias ? (
                <div
                    className={`a-menu-accord__category ${
                        isActive && '--active'
                    }`}
                    onClick={() => {
                        setActiveItem(index);
                        toggleActive(!isActive);
                    }}
                >
                    <button className={classMenuAccordionBtn}>
                        {category.nombre}
                    </button>
                    <span className={classMenuAccordionBtnIcon}></span>
                </div>
            ) : (
                <Link
                    className="a-menu-accord__link"
                    to={getLocationRef(category.redireccion)}
                    onClick={() => {
                        onItemTraceShiping();
                    }}
                >
                    {category.nombre}
                </Link>
            )}
            <ul className={classMenuAccordionSub}>
                {existCategory &&
                    category.referencias.map((option, idx) => {
                        return (
                            <div
                                className="a-menu-accord__sub-container"
                                key={`item-${idx}`}
                            >
                                {option.referencias ? (
                                    <li
                                        className="a-menu-accord__sub-item"
                                        onClick={() => {
                                            selectThirdFileMenu(idx);
                                            setSelectedSubMenuIndex(idx);
                                            handleFileMenuChange(idx);
                                        }}
                                    >
                                        <SubmenuElement
                                            item={option}
                                            index={idx}
                                            subOption={false}
                                            bold={!option?.redireccion}
                                            tooltipLeft={false}
                                            traceLabel={`${validateTitle(
                                                category.titulo
                                            )} ${normalizeWords(
                                                category.nombre
                                            )} :: ${normalizeWords(
                                                option.nombre
                                            )}`}
                                            isIcon={props.isIcon}
                                            haveChild={true}
                                            crossIcon={true}
                                            selectedChild={
                                                selectedSubMenuIndex === idx
                                            }
                                        />
                                        {thirdFileMenu &&
                                        selectedSubMenuIndex === idx
                                            ? thirdFileMenu.map(
                                                  (item, index) => {
                                                      return (
                                                          <div
                                                              className="m-submenu__column-options"
                                                              key={`option-subMenu-${index}`}
                                                          >
                                                              <SubmenuElement
                                                                  item={item}
                                                                  index={index}
                                                                  subOption={
                                                                      false
                                                                  }
                                                                  bold={false}
                                                                  tooltipLeft={
                                                                      false
                                                                  }
                                                                  traceLabel={`${validateTitle(
                                                                      category.titulo
                                                                  )} ${normalizeWords(
                                                                      category.nombre
                                                                  )} :: ${normalizeWords(
                                                                      option.nombre
                                                                  )}`}
                                                                  isIcon={false}
                                                                  isTitle={true}
                                                                  onlyRedirection={
                                                                      true
                                                                  }
                                                              />
                                                          </div>
                                                      );
                                                  }
                                              )
                                            : null}
                                    </li>
                                ) : (
                                    menuList(
                                        option,
                                        idx,
                                        option.redireccion,
                                        false,
                                        `${validateTitle(
                                            category.titulo
                                        )} ${normalizeWords(
                                            category.nombre
                                        )} :: ${normalizeWords(option.nombre)}`,
                                        true
                                    )
                                )}
                            </div>
                        );
                    })}
                <div className="a-menu-accord__sub-registerInfo">
                    {children}
                </div>
            </ul>
        </div>
    );
};

export default MenuAccordion;
